import React from 'react';

import { css } from '@emotion/css';
import { Empty } from 'antd';

import { FlexSpace } from 'components/FlexSpace';

export function DailyWorkflowEmptyState({ hasNoRules }: { hasNoRules?: boolean }) {
  return (
    <FlexSpace
      direction="column"
      alignItems="center"
      justify="flex-start"
      className={css`
        flex: 1;
        margin: auto;
      `}
    >
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Data" />
      {hasNoRules && (
        <div
          className={css`
            text-align: center;
            padding: 0 15%;
            font-size: 14px;
            font-weight: 400;
            color: #666;
          `}
        >
          You don't have any Daily Workflow rules enabled. To learn how to set them up, please visit our Rules module if
          you're a Recurrency Admin or contact your Customer Success Manager for guidance
        </div>
      )}
    </FlexSpace>
  );
}
